// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__TcHsI","inputSearch":"Search_inputSearch__fAOBl"};